import React, { useState, useEffect } from 'react';
import './UpgradePrompt.css';
import api from '../../api';
import Toast from '../../UI/Toast';

const UpgradePrompt = ({ autoCheckout = false }) => {
    const [isProcessingCheckout, setIsProcessingCheckout] = useState(false);
    const [toast, setToast] = useState({ show: false, type: '', message: '' });

    // Déclencher automatiquement le checkout si autoCheckout est true
    useEffect(() => {
        if (autoCheckout) {
            handleCheckout();
        }
    }, [autoCheckout]);

    const handleCheckout = async () => {
        try {
            setIsProcessingCheckout(true);
            
            // Définir votre identifiant de prix Stripe
            const stripePriceId = process.env.REACT_APP_MONTH_PRICE_ID; // monthly subscription
            
            // Create subscription checkout with 7-day trial
            const response = await api.post(`/subscription_checkout/${stripePriceId}`);
            
            // Récupérer l'URL de redirection depuis la réponse
            const checkoutUrl = response.data.checkout_url;
            
            // Rediriger vers l'URL de checkout Stripe
            window.location.href = checkoutUrl;
        } catch (error) {
            console.error('Erreur lors de la création de la session d’abonnement:', error);
            
            setToast({
                show: true,
                type: 'error',
                message: "An error occurred while preparing your subscription. Please try again."
            });
            
            setIsProcessingCheckout(false);
        }
    };

    return (
        <div className="upgrade-prompt">
            <div className="upgrade-content">
                <h2>
                    <i className="fas fa-crown"></i>
                    {" "}Unlock Premium Content System
                </h2>
                <p className="subtitle">Transform any YouTube video into multiple high-converting content formats in seconds!</p>
                
                <div className="price-tag">
                    <span className="current-price">$19</span>
                </div>
                
                <p className="limited-offer">7-DAY FREE TRIAL • $19/mo or $97/yr</p>
                
                <ul>
                    <li>✓ Generate unlimited content with your own API key</li>
                    <li>✓ Access to latest AI models (GPT-4o, o3, 4.1)</li>
                    <li>✓ Access all YT CopyCat tools and features</li>
                    <li>✓ Generate blog posts, summaries, and podcast scripts</li>
                    <li>✓ Convert podcast scripts to professional audio files</li>
                    <li>✓ Choose from 10+ premium TTS voices</li>
                    <li>✓ Create tweets, LinkedIn posts, and newsletters</li>
                    <li>✓ Build custom prompts for any content type</li>
                    <li>✓ Support for 30+ languages</li>
                    <li>✓ Save $1,000+ on content creation and voice-over costs</li>
                </ul>

                <p className="value-prop">Stop struggling with expensive, time-consuming content creation. Join thousands of smart content creators leveraging YT Copycat today!</p>

                <button 
                    className="button-important" 
                    onClick={handleCheckout} 
                    disabled={isProcessingCheckout}
                >
                    <div className="inner">
                        <i className="fas fa-crown"></i>
                        {isProcessingCheckout ? 'PROCESSING...' : 'START 7-DAY FREE TRIAL'}
                    </div>
                </button>
            </div>
            {toast.show && (
                <Toast
                    type={toast.type}
                    message={toast.message}
                    onClose={() => setToast({ ...toast, show: false })}
                    duration={6000}
                />
            )}
        </div>
    );
};

export default UpgradePrompt; 